﻿export default function Recaptcha() {
    let score = grecaptcha.execute("6Ld5VMIUAAAAAKLO0T0MmJ5FqT5rrWJjJstV0IB8", { action: 'submitform' }).then(
        response => fetch("/RecaptchaV3Vverify?token=" + response).then(
            returnedScore => returnedScore.json()
        ).then(
            data => data['score']
        )
    )

    return score;
}